var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bids-list tab-table p-2"},[_c('BidsTable',{attrs:{"exclude-search-fields":_vm.excludeSearchFields,"exclude-columns":['stock_no', 'sale_no']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }